<template>
<div class="chapter">
<div class="inner_page">
<h1 class="section">TABLE OF CONTENTS</h1>
<p class="center"><a class="link" href="#/ded">Dedication</a></p>
<p class="center"><a class="link" href="#/ack">Acknowledgments</a></p>
<p class="center1"><a class="link" href="#/chapter1">Hitting the Road</a></p>
<p class="center"><a class="link" href="#/chapter2">Highway Robbery</a></p>
<p class="center"><span class="link" href="#/chapter3" title="Link target outside of Sample">Off-Loaded</span></p>
<p class="center"><span class="link" href="#/chapter4" title="Link target outside of Sample">In For Repair</span></p>
<p class="center"><span class="link" href="#/chapter5" title="Link target outside of Sample">Murder On Site</span></p>
<p class="center"><span class="link" href="#/chapter6" title="Link target outside of Sample">Just in Time</span></p>
<p class="center"><span class="link" href="#/chapter7" title="Link target outside of Sample">The Dispatcher</span></p>
<p class="center"><span class="link" href="#/chapter8" title="Link target outside of Sample">Drivers of the Purple Rage</span></p>
<p class="center"><span class="link" href="#/chapter9" title="Link target outside of Sample">Unaccustomed</span></p>
<p class="center"><span class="link" href="#/chapter10" title="Link target outside of Sample">Death Rides a Semi</span></p>
<p class="center1"><span class="link" href="#/afterword" title="Link target outside of Sample">Afterword: The Mark Dalton Story</span></p>
<p class="center1"><span class="link" href="#/ata" title="Link target outside of Sample">About the Author</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// toc.vue?50a7341c